<template>
  <div id="cart">
    <Spinner v-if="isLoading" />
    <OrderError
      v-if="hasErrors"
      :error="getCurrentErrorMessage"
      :descr="getCurrentErrorDescr"
      :level="getCurrentErrorLevel"
      @onButtonClicked="createNewOrder"
    />
    <LogoHeader :shopCode="getShopCode" />
    <article class="bistro-weborders-body">
      <article v-if="getProducts.length > 0">
        <AdditionalsDialog
          :showDialog="hasToShowAdditionalDialog"
          :options="getAdditionals"
          :selectedOptions="selectedOptions"
          @dismiss="dismissAdditionalDialog()"
          @addProduct="addProductAdditionalDialog()"
        />
        <section class="">
          <div
            v-for="(prodByDept, index) in getProducts"
            :key="index"
            class="col-xs-3"
          >
            <h1 class="menu-name">{{ prodByDept.name }}</h1>

            <div
              v-for="(product, index) in prodByDept.products"
              :key="index"
              class="col-xs-3"
            >
              <ProductItem
                v-if="hasAdditionals(product) === false"
                :product="product"
                :quantity="getQuantity(product.sku)"
                @plusQuantity="plusQuantity(product)"
                @lessQuantity="lessQuantity(product.sku)"
                :showBandAid="true"
              />
              <ProductItemForAdditionals
                v-else
                :product="product"
                @click="showAdditionalsModal(product)"
                :showBandAid="true"
              />
            </div>
          </div>

          <br />
        </section>
      </article>

      <article v-else-if="loaded" class="menuError">
        <h4>No hay productos disponibles</h4>
      </article>
    </article>

    <Footer />
  </div>
</template>
<script>
import LogoHeader from "../Components/LogoHeader";
import Footer from "../Components/Footer";
import ProductItem from "../Components/ProductItem";
import OrderError from "../Components/OrderError";
import Spinner from "../Components/Spinner";
import spinner_mixin from "../mixins/Spinner_Mixin";
import mobile_detection from "../mixins/mobile_detection";
import order_error_mixin from "../mixins/OrderError_Mixin";
import cart_mixin from "../mixins/Cart_Mixin";
import AdditionalsDialog from "../Components/AdditionalsDialog";
import ProductItemForAdditionals from "../Components/ProductItemForAdditionals";
import "../assets/site.css";

export default {
  mixins: [cart_mixin, spinner_mixin, order_error_mixin, mobile_detection],
  name: "cart",
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    this.processCart();
  },
  methods: {},
  computed: {},
  components: {
    LogoHeader,
    Footer,
    ProductItem,
    OrderError,
    Spinner,
    AdditionalsDialog,
    ProductItemForAdditionals,
  },
};
</script>

<style lang="scss" scoped>
#cart {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.menu-name {
  margin-top: 2%;
  font-size: 2em;
}
.bwo-title-inline {
  display: inline;
}

.bwo-menu-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.item-content {
  margin: 20px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Cart.vue